<template>
  <div>
    <!-- ヘッダ -->
    <comMaintHeaderAuth :propScreenTitle="screenTitle" :propSrcScreenId="screenId" :propMenuInfo1="username" :propMenuInfo2="deptname"></comMaintHeaderAuth>
    <v-main>
      <v-container fluid>
        <!-- メッセージエリア -->
        <v-alert border="bottom" colored-border type="info" elevation="2">
          {{ messageArea }}
        </v-alert>

        <!-- 申込キー情報 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="9" lg="9" xl="9">
            <v-alert border="left" outlined type="success" text icon="mdi-map-marker-alert-outline" prominent>
              <v-row dense style="height: 60px;" >
                <v-col cols="4" sm="4" md="4" lg="3" xl="3" >
                  <p>申込番号：{{ dispRequestNo }}</p>
                </v-col>
                <v-col cols="4" sm="4" md="4" lg="3" xl="3" >
                  <p>申込日時：{{ dispRequestDate }}</p>
                </v-col>
                
                  <template v-if="selectedProgress == '81'">
                    <v-col cols="4" sm="4" md="4" lg="4" xl="4" class="ma-0">
                    <span small class="red--text">このお申込みはキャンセルされています。</span>
                    </v-col>
                  </template>
                  <template v-else>
                    <v-col cols="2" sm="2" md="2" lg="2" xl="2" >
                    <v-select
                      v-model="selectedProgress"
                      :items="progress"
                      item-text="name"
                      item-value="cd"
                      chips
                      label="進捗状況を変更できます"
                      return-object
                      @change="changeProgress(progress.cd)"
                    ></v-select>
                    </v-col>
                  </template>
                
                <!-- <v-col cols="2" sm="2" md="2" lg="3" xl="3" class="d-flex align-center justify-center" >
                  <template v-if="verifyStatus.name == '未確認'">
                    <v-btn medium color="red" dark min-width="80px" elevation="5" @click="requestVerify(requestNo, managerName, managerNameKana, mailAddress)">{{verifyStatus.name}}</v-btn>
                  </template>
                  <template v-else-if="verifyStatus.name != null && verifyStatus.name != ''">
                  <v-chip outlined :color="verifyStatus.color" :text-color="verifyStatus.color" >
                    <v-icon left>{{ verifyStatus.icon }}</v-icon>
                    {{ verifyStatus.name }}
                  </v-chip>
                  </template>

                  <v-btn fab small color="indigo darken-1" dark class="mx-2" @click="checkVerifyStatus(receiptNo, loginUserNo, mailAddress)">
                    <v-icon dark>mdi-cloud-search-outline</v-icon>
                  </v-btn>
                </v-col> -->
              </v-row>
              <v-row style="height: 20px;" class="caption d-flex align-center justify-start">
                <v-col cols="4" sm="4" md="4" lg="4" xl="3">
                  <p class="ml-1">{{ dispUserKanaNM }}</p>
                </v-col>
                <v-col cols="4" sm="4" md="4" lg="4" xl="3" >
                  <p class="ml-1">{{ dispCompanyKanaNm }}</p>
                </v-col>
                <v-col cols="4" sm="4" md="4" lg="4" xl="4" >
                </v-col>
              </v-row>
              <v-row style="height: 50px;">
                <v-col cols="4" sm="4" md="4" lg="4" xl="3" >
                  <p>{{ dispUserNM }}</p>
                </v-col>
                <v-col cols="4" sm="4" md="4" lg="4" xl="3" >
                  <p>{{ dispCompanyNm }}</p>
                </v-col>
                <v-col cols="4" sm="4" md="4" lg="4" xl="4" class="d-flex align-start justify-end">
                  <v-btn medium color="indigo darken-1" dark min-width="140px" @click="dispMemberInfoView()">会員詳細</v-btn>
                </v-col>
              </v-row>
            </v-alert>
          </v-col>
        </v-row>

        <!-- 本人確認状態 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoVerifyInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  expand-icon="mdi-menu-down"
                  class="panel-title"
                >
                  <label>本人確認状態</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <v-row>
                    <v-col cols="12">
                      <template v-if="verifyStatus.name == '未確認'">
                        <v-btn medium color="red" :disabled="unconfirmedInactive" class="white--text" min-width="80px" elevation="5" @click="requestVerify(requestNo, managerName, managerNameKana, mailAddress)">{{verifyStatus.name}}</v-btn>
                      </template>
                      <template v-else-if="verifyStatus.name != null && verifyStatus.name != ''">
                        <v-chip outlined :color="verifyStatus.color" :text-color="verifyStatus.color" >
                          <v-icon left>{{ verifyStatus.icon }}</v-icon>
                          {{ verifyStatus.name }}
                        </v-chip>
                      </template>
                      <template v-if="verifyStatus.name != '未確認'">
                      <v-btn shaped color="indigo darken-1" dark class="mx-2" @click="checkVerifyStatus(receiptNo, loginUserNo, mailAddress)">
                        <!-- <v-icon dark>mdi-cloud-search-outline</v-icon> -->
                        <v-icon dark>mdi-database-search-outline</v-icon>
                        確認状態問い合わせ
                      </v-btn>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="2"  class="d-flex align-center justify-start">
                      <template v-if="verifyDealResult.name != null && verifyDealResult.name != ''">
                        <v-chip large outlined :color="verifyDealResult.color" :text-color="verifyDealResult.color" >
                          <v-icon left>{{ verifyDealResult.icon }}</v-icon>
                            {{ verifyDealResult.name }}
                        </v-chip>
                      </template>
                    </v-col>
                    <v-col cols="10">
                      <p> {{verifyDealResultComment}} </p>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <!-- プラン情報 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoPlanInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  expand-icon="mdi-menu-down"
                  class="panel-title"
                >
                  <label>申込プラン</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <span v-html="dispPlanNm"></span>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <!-- 役員情報 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoOfficerInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="panel-title"
                  expand-icon="mdi-menu-down"
                >
                  <label class="moji mojihead">役員情報</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content>

                  <v-row class="pl-2 pt-6">
                    <v-col cols="12">
                      <span v-html="dispChangeOfficerDate"></span>
                    </v-col>
                  </v-row>
                <v-data-table
                  :headers="headers"
                  :items="desserts"
                  :single-expand="dispOfficerSingleExpand"
                  item-key="changeNo"
                  show-expand 
                  disable-pagination
                  hide-default-footer
                  :disable-sort="true"
                  class="v-data-table elevation-3 v-dtbl-md-1 mt-5"
                >
                  <!-- <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div class="expand-box">
                        <span class="box-title">役員変更詳細</span>
                        <p v-html="item.regmatter"></p>
                      </div>       
                    </td>
                  </template> -->
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <div class="expand-box">
                        <span class="box-title">役員住所</span>
                        <p v-html="item.address"></p>
                      </div>       
                    </td>
                  </template>
                </v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <!-- 登記情報ファイル情報 -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoFileInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="panel-title"
                  expand-icon="mdi-menu-down"
                >
                  <label class="moji mojihead">登記情報ファイル</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <v-row>
                    <v-col cols="8"></v-col>
                    <v-col cols="2" class="d-flex align-center justify-end pa-0 mr-0">
                      <template v-if="fileUploadFlg">
                        <v-file-input @change="uploadFileInfo($event)" @click="clearFileInfo($event)" outlined dense accept=".pdf" class="file-input d-flex align-end justify-center mr-0" ref="vFileInput" prepend-icon="" height="4" hide-input>
                          <template v-slot:append-outer>
                            <div @click="handleClickAppendOuter()">
                              <v-btn elevation="4" color="indigo darken-1" class="sentaku-btn2 white--text">アップロード</v-btn>
                            </div>
                          </template>
                        </v-file-input>
                      </template>
                    </v-col>
                    <v-col cols="2" class="d-flex align-center justify-center pa-0">
                      <template v-if="fileUploadFlg">
                        <v-btn color="indigo darken-1" dark min-width="80px" @click="deleteFileInfo(requestNo, fileId)">削除</v-btn>
                      </template>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <iframe id="iframeFile" :src="dispPdfFileBlobUrl" width="100%" scrolling="no"></iframe>
                      <!-- <input type="file" accept="image/*" @change="onFileChange($event)"> -->
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
        

        <!-- 登記変更詳細情報 -->
        <!-- <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoDatailInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="panel-title"
                  expand-icon="mdi-menu-down"
                >
                  <label class="moji mojihead">登記変更詳細情報</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <span v-html="dispRegChgInfo"></span>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row> -->
        
        <!-- コメント -->
        <v-row justify="center" align-content="center">
          <v-col cols="12" sm="10" md="10" lg="9" xl="9">
            <v-expansion-panels :tile="true" v-model="panelNoCommentInfo">
              <v-expansion-panel>
                <v-expansion-panel-header
                  class="panel-title"
                  expand-icon="mdi-menu-down"
                >
                  <label class="moji mojihead">コメント</label>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="mt-4">
                  <v-row class="mb-1">
                    <v-col cols="12" class="d-flex align-start justify-end">
                      <v-btn x-large color="indigo darken-1" dark min-width="100px" @click="regstComment()">登録</v-btn>
                    </v-col>
                  </v-row>
                  <v-textarea outlined id="textarea" v-model="inputCommentInfo" rows="10" overflow="scroll"></v-textarea>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-sheet min-height="1vh" color="transparent"></v-sheet>
          </v-col>
        </v-row>
        <!-- ボタン -->
        <v-row justify="center" align-content="start">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
            
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="d-flex align-center justify-center">
              <v-btn x-large color="indigo darken-1" dark min-width="200px" @click="back()">戻る</v-btn>
          </v-col>
        </v-row>

        <!-- その他 -->
        <comMessage :msg="dlgMsg.msg" :isOpen="dlgMsg.isOpen" :doYes="dlgMsg.doYes"/>
        <comMessage :msg="dlgMsgErr.msg" :isOpen="dlgMsgErr.isOpen" :doYes="dlgMsgErr.doYes"/>
        <comMessageConfirm :msg="dlgMsgConfirmDel.msg" :isOpen="dlgMsgConfirmDel.isOpen" :doYes="dlgMsgConfirmDel.doYes" :doNo="dlgMsgConfirmDel.doNo" />
        <comMessageConfirm :msg="dlgMsgCheckVerifyStatusConfirm.msg" :isOpen="dlgMsgCheckVerifyStatusConfirm.isOpen" :doYes="dlgMsgCheckVerifyStatusConfirm.doYes" :doNo="dlgMsgCheckVerifyStatusConfirm.doNo" />
        <comMemberInfo :id="dlgMemberInfo.id" :isOpen="dlgMemberInfo.isOpen" :doYes="dlgMemberInfo.doYes"/>
        <comMainteVerifyRequest :msg="dlgVfReq.msg" :isOpen="dlgVfReq.isOpen" :requestNo="dlgVfReq.requestNo" :managerNameKana="dlgVfReq.managerNameKana" :managerName="dlgVfReq.managerName" :mailAddress="dlgVfReq.mailAddress" :doYes="dlgVfReq.doYes" :doNo="dlgVfReq.doNo"/>
        <v-fab-transition>
          <v-btn
            color="indigo"
            fab
            dark
            large
            absolute
            right
            style="bottom:20px; position:fixed;"
            @click="$vuetify.goTo(0)"  
            v-show="buttonActive"
          >
            <v-icon>mdi-navigation</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import Constants from "../common/constants";
import Utils from "../common/utils";
export default {
  name: "MainteRequestConfirm",
  data() {
    return {
      username: "",
      deptname: "",
      screenTitle: "[メンテ] お申込確認",
      screenId: "MTR200",
      messageArea: "",
      moveTopButton: 'right',

      requestNo: "",
      fileId:"",
      fileUploadFlg: false,
      planMstrList: null,
      reasonMstrList: null,
      selectedPlanIdList: null,
      verifyStatusKbnMstList: null,
      dealResultKbnList: null,

      progress: [],
      selectedProgress: "",

      verifyStatus: {},
      verifyDealResult: {},

      dispCustomerId: "",

      dispRequestNo: "",
      dispRequestDate: "",
      dispPlanNm: "",
      dispPdfFileBlobUrl: null,
      dispChangeOfficerDate: "",
      dispOfficerSingleExpand: true,
      dispRegChgInfo: "",
      inputCommentInfo: "",
      initCommentInfo: "",
      
      dispUserKanaNM: "",
      dispCompanyKanaNm: "",
      dispUserNM: "",
      dispCompanyNm: "",
      
      panelNoVerifyInfo: 0,
      panelNoPlanInfo: 0,
      panelNoFileInfo: 0,
      panelNoOfficerInfo: 0,
      panelNoDatailInfo: 0,
      panelNoCommentInfo: 0,

      verifyDealResultComment: "",

      detailUpdateDatetime: "",
      detailUpdateUserId: "",

      managerName: "", 
      managerNameKana: "", 
      mailAddress:"",
      receiptNo:"",
      loginUserNo: "",

      buttonActive: false,
      scroll: 0,
      
      unconfirmedInactive: false,

      dlgMemberInfo: {
        id: this.dispCustomerId,
        isOpen: false,
        doYes: () => {
          this.dlgMemberInfo.isOpen = false;
        },
      },
      dlgMsg: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsg.isOpen = false;
        },
      },
      dlgMsgErr: {
        msg: "",
        isOpen: false,
        doYes: () => {
          this.dlgMsgErr.isOpen = false;
        },
      },
      dlgMsgCheckVerifyStatusConfirm: {
        msg: this.$i18n.t('msg.wrn.mt010'),
        systemId: "",
        receiptNo: "",
        loginUserNo: "",
        mailAddress: "",
        isOpen: false,
        doYes: () => {
          
          this.dlgMsgCheckVerifyStatusConfirm.isOpen = false;
          // 本人確認処置状況取得
          this.getVerifyStatus(this.dlgMsgCheckVerifyStatusConfirm.systemId, this.dlgMsgCheckVerifyStatusConfirm.receiptNo, 
            this.dlgMsgCheckVerifyStatusConfirm.loginUserNo, this.dlgMsgCheckVerifyStatusConfirm.mailAddress);
        },
        doNo: () => {
          this.dlgMsgCheckVerifyStatusConfirm.isOpen = false;
        },
      },
      dlgMsgConfirmDel: {
        msg: this.$i18n.t('msg.wrn.cm012', ['登記情報ファイル']),
        requestNo: "",
        fileId:"",
        isOpen: false,
        doYes: () => {
          this.suspend(this.dlgMsgConfirmDel.requestNo, this.dlgMsgConfirmDel.fileId);
          this.dlgMsgConfirmDel.isOpen = false;
        },
        doNo: () => {
          this.dlgMsgConfirmDel.isOpen = false;
        },
      },

     dlgVfReq: {
        msg: this.$i18n.t('msg.wrn.mb020'),
        isOpen: false,
        requestNo: "",
        managerNameKana: "",
        managerName: "",
        mailAddress:"",
        sex: "",
        birthDate: "",
        doYes: () => {
          // 本人確認依頼
          this.dlgVfReq.isOpen = false;
          // 再表示
          this.initialize();
        },
        doNo: () => {
          this.dlgVfReq.isOpen = false;
        },
      },

      headers: [
        { text: "No", align: "center", value: "changeNo", width: "5%"  },
        { text: "資格(役員役職)", align: "start", value: "officialPosition", width: "15%" },
        { text: "氏名", align: "start", value: "name", width: "25%" },
        // { text: "氏名(フリガナ)", align: "start", value: "nameKana", width: "25%" },
        { text: "登記の事由", align: "start", value: "changeOfficerClassName", width: "15%" },
        // { text: "役員変更詳細", align: "center", value: "data-table-expand", width: "15%" },
        { text: "役員住所", align: "center", value: "data-table-expand", width: "15%" },

        // { text: "原因年月日", align: "center", value: "causeDate", width: "10%" },
      ],
      desserts: [],


    };
  },
  mounted() {
    window.addEventListener('scroll', this.scrollWindow);
  },
  created() {
    this.initialize();
  },
  beforeRouteLeave(to, from, next) {
    // 画面用データストア破棄
    if (to.name != 'MTR100') {
      this.$store.commit("mainteRequestListSearch/resetState");
    }
    next();
  },
  methods: {


   /*
    * 初期表示
    */
    initialize: function() {
      this.setAuthUserInfo();
      this.messageArea = this.$i18n.t('webmsg.mtr200.area');
      this.requestNo = Utils.removeChar(this.$route.params.requestNo, '-');
      // let loggedUserInfo = this.$store.getters["authcUser/getLoggedUserInfo"];
      // this.userId = loggedUserInfo['id'];
      /* データ表示 */
      this.dispSearchData(this.requestNo);
    },

    setAuthUserInfo : function() {      
      let authInfo = this.setMainteLoginInfoMixin();
      this.username = authInfo['username'];
      this.deptname = authInfo['deptname'];
    },

    /**
     * 「削除」ボタン押下
     */
    deleteFileInfo(requestNo,fileId) {
      this.dlgMsgConfirmDel.requestNo = requestNo;
      this.dlgMsgConfirmDel.fileId = fileId;
      this.dlgMsgConfirmDel.isOpen = true;
    },

    /*
    * 本人確認状況確認ボタン押下
    */
    checkVerifyStatus: function(receiptNo, loginUserNo, mailAddress) {
      this.dlgMsgCheckVerifyStatusConfirm.systemId = Constants.SYS_ID_TOUKI;
      this.dlgMsgCheckVerifyStatusConfirm.receiptNo = receiptNo;
      this.dlgMsgCheckVerifyStatusConfirm.loginUserNo = loginUserNo;
      this.dlgMsgCheckVerifyStatusConfirm.mailAddress = mailAddress;
      this.dlgMsgCheckVerifyStatusConfirm.isOpen = true;
    },

    /*
    * 未確認ボタン押下（本人確認依頼）
    */
    requestVerify: function(requestNo, name, nameKana, mailAddress) {
      this.dlgVfReq.requestNo = requestNo;
      this.dlgVfReq.managerName = name;
      this.dlgVfReq.managerNameKana = nameKana;
      this.dlgVfReq.mailAddress = mailAddress;
      this.dlgVfReq.isOpen = true;
    },    

   /*
    * 「会員詳細」ボタン押下
    */
    dispMemberInfoView() {
      // メッセージ表示
      this.dlgMemberInfo.id = this.dispCustomerId;
      this.dlgMemberInfo.isOpen = true;
    },

   /*
    * 「戻る」ボタン押下
    */
    back: function() {
      // 遷移元画面へ戻る
      let srcScreenId = this.$route.params['srcScreenId'];
      if (srcScreenId == null) { 
        this.$router.push(this.$router.resolve({ name: "MTO100" }).href);
      } else {
         this.$router.push(this.$router.resolve({ name: srcScreenId }).href);
      }
    },

    /*
    * 申込済情報取得・表示
    */
    dispSearchData : async function(requestNo) {
      
      try {
        let apiurl = Constants.getUrlApiMTR200G01(requestNo);
        let accessToken = this.$store.getters["authcUser/getAccessToken"];
        // サービス呼び出し
        let response = await this.$axios.get(apiurl,
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken},
              responseType: "json",
            }); 
        // 申込済情報表示
        this.dispSearchResultData(response.data);
        // ファイル情報取得・表示
        this.dispSearchDataForFileInfo(response.data);
      } catch(error) {
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm100', ['申込内容']);
          this.dlgMsgErr.isOpen = true;
          this.desserts.push({});
      }
      return;
    },

    /*
    * ファイル情報取得・表示
    */
    dispSearchDataForFileInfo : async function(apiResponseData) {
       if (apiResponseData == null) {
        return;
      }
      let responseDto = apiResponseData.data;
      let resultDto = responseDto.requestDetailsConfirmResultDto;
      // let fileId = resultDto.fileId; 
      this.fileId = resultDto.fileId;
      if (this.fileId == 'null') {
        return;
      }
      let apiurl = Constants.getUrlApiMTR200G02(this.fileId);
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let response = await this.$axios.get(apiurl, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "blob",
            });
        // 申込済情報表示
        if (response.data == null || response.data.size == 0) {
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm100', ['ファイル情報']);
          this.dlgMsgErr.isOpen = true;
          this.desserts.push({});
          return;
        }
        this.dispPdfFileBlobUrl = window.URL.createObjectURL(response.data);
      } catch(error) {
          this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm100', ['申込内容']);
          this.dlgMsgErr.isOpen = true;
          this.desserts.push({});
      }
      return;
    },    

   /*
    * 「進捗状況」プルダウンチェンジ
    */
    changeProgress: async function() {

      // 登録サービス呼び出し
      let responseDto = null;
      try {
        let apiurl = Constants.getUrlApiMTR200P01(this.requestNo);
        let accessToken = this.$store.getters["authcUser/getAccessToken"];
        // 入力データ
        let data = JSON.stringify(this.createRequesProgressData());
        // API呼出
        let response = await this.$axios.post(apiurl, data, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseDto = response.data;
        if (responseDto.statusCd == 200) {
          this.dlgMsg.msg = responseDto.message;
          this.dlgMsg.isOpen = true;
          this.dispSearchData(this.requestNo);
        } else {
            // 処理異常
        let errorList = responseDto.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
        } else{
          this.dlgMsgErr.msg = responseDto.message;
          this.dlgMsgErr.isOpen = true;
        }
        }
      } catch(error) {
        console.log(error);
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['進捗状況の変更']);
        this.dlgMsgErr.isOpen = true;
      }
    }, 
    
   /*
    * 「登録(コメント)」ボタン押下
    */
    regstComment: async function() {
      // チェック
      if (this.inputCommentInfo == null || this.inputCommentInfo =='') {
        return;
      }
      // 登録サービス呼び出し
      let responseDto = null;
      try {
        let apiurl = Constants.getUrlApiMTR200P02(this.requestNo);
        let accessToken = this.$store.getters["authcUser/getAccessToken"];
        // 入力データ
        let data = JSON.stringify(this.createRequesCommentData());
        // API呼出
        let response = await this.$axios.post(apiurl, data, 
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseDto = response.data;
        if (responseDto.statusCd == 200) {
          this.dlgMsg.msg = responseDto.message;
          this.dlgMsg.isOpen = true;
        } else {
          // 処理異常
        let errorList = responseDto.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsg.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsg.isOpen = true;
        } else{
          this.dlgMsgErr.msg = responseDto.message;
          this.dlgMsgErr.isOpen = true;
        }
        }
      } catch(error) {
        console.log(error);
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm111', ['コメント']);
        this.dlgMsgErr.isOpen = true;
      }
    }, 
    
    /*
    * 「アップロード」ボタン押下
    */
    uploadFileInfo: async function(file) {
      // サービス呼び出し
      let apiurl = Constants.getUrlApiMTR200P03(this.requestNo, this.fileId);
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      // 入力データ
      const requestFileData = new FormData()
      requestFileData.append('fileData', file)
      let data = requestFileData;
      let responseDto = null;
      try {
        // API呼出
        let response = await this.$axios.post(apiurl, data, 
        {
          headers: {"X-AUTH-TOKEN": "Bearer " + accessToken}, 
            responseType: "json",
        });
        responseDto = response.data;
        if (responseDto.statusCd != 200) {
          this.dlgMsgErr.msg = responseDto.message;
          this.dlgMsgErr.isOpen = true;
        } else {
         //ファイル情報表示
         this.dispSearchDataForFileInfo(responseDto);
        }
      } catch(error) {
        console.log(error);
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm111', ['登記情報ファイル']);
        this.dlgMsgErr.isOpen = true;
      }
    },
    clearFileInfo : function(event) {
      event.target.value = "";
    },
    handleClickAppendOuter() {
      this.$refs.vFileInput.$el.querySelector("input").click();
    },

    /*
    * 「削除」ボタン押下
    */
    suspend: async function(requestNo, fileId) {
      // サービス呼び出し
      let apiurl = Constants.getUrlApiMTR200P04(requestNo, fileId);
      let data = {};
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      let responseDto = null;
      try {
        // API呼出
        let response = await this.$axios.put(apiurl, data, 
        {
          headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken},  
          responseType: "json",
        });
        responseDto = response.data;
        if (responseDto.statusCd != 200) {
          this.dlgMsgErr.msg = responseDto.message;
          this.dlgMsgErr.isOpen = true;
        } else {
         //ファイル情報表示
         this.dispPdfFileBlobUrl = null;
         this.fileId = null;
        }
      } catch(error) {
        console.log(error);
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm113', ['登記情報ファイル']);
        this.dlgMsgErr.isOpen = true;
      }
    },    

    /*
    * 本人確認処置状況取得
    */
    getVerifyStatus : async function(systemId, receiptNo, userNo, mailAddress) {
      let responseDto;

      try {
        let apiurl = Constants.URL_API_ERV100P01;
        // 入力データ
        let data = JSON.stringify(this.verifyStatusSearchData(systemId, receiptNo, userNo, mailAddress));
        // API呼出
        let response = await this.$axios.post(apiurl, data,
            {
              headers: {"content-type": "application/json"},  
              responseType: "json",
            });
        responseDto = response.data;
        let verifyStatusResultData = responseDto.data;
        // 完了メッセージ表示
        if (!this.showDialogMsgAfterAPICall(responseDto)) {
          this.regsterVerifyStatusResult(verifyStatusResultData);
        }
      } catch(error) {
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['本人確認処置状況の確認']);
        this.dlgMsgErr.isOpen = true;
      } 
     
    },

    /*
    * 本人確認処置状況登録
    */
    regsterVerifyStatusResult: async function(verifyStatusResultData) {
      let responseDto;
      let accessToken = this.$store.getters["authcUser/getAccessToken"];
      try {
        let apiurl = Constants.getUrlApiMTR200P05(this.requestNo);
        // 入力データ
        let data = JSON.stringify(verifyStatusResultData);
        // API呼出
        let response = await this.$axios.put(apiurl, data,
            {
              headers: {"content-type": "application/json", "X-AUTH-TOKEN": "Bearer " + accessToken}, 
              responseType: "json",
            });
        responseDto = response.data;
        if (responseDto.statusCd != 200) {
          this.dlgMsgErr.msg = responseDto.message;
          this.dlgMsgErr.isOpen = true;
        } else {
          // 申込情報再取得・再表示
          this.dispSearchData(this.requestNo);
        }
      } catch(error) {
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['本人確認の状況確認']);
        this.dlgMsgErr.isOpen = true;
      } 
    },    

    /*
    * 検索用データ生成
    */
    verifyStatusSearchData: function(systemId, receiptNo, userNo, mailAddress) {
      let reqData = {};
      reqData['systemId'] = systemId;
      reqData['receiptNo'] = receiptNo;
      reqData['userNo'] = userNo;
      reqData['mailAddress'] = mailAddress;
      return reqData;

    },

    /*
    * 進捗状況更新用データ生成
    */
    createRequesProgressData: function() {
      let requestResltData = {};
      requestResltData['detailUpdateDatetime'] = this.detailUpdateDatetime;
      requestResltData['detailUpdateUserId'] = this.detailUpdateUserId;
      let requestData = {};
      requestData['selectedProgress'] = this.selectedProgress['cd'];
      requestData['requestDetailsConfirmResultDto'] = requestResltData;
      return requestData;
    },

    /*
    * コメント登録用データ生成
    */
    createRequesCommentData: function() {
      let requestResltData = {};
      requestResltData['comment'] = this.initCommentInfo;
      let requestData = {};
      requestData['inputComment'] = this.inputCommentInfo;
      requestData['requestDetailsConfirmResultDto'] = requestResltData;
      return requestData;
    },

    /*
    * 画面表示用データの生成(申込済情報)
    */
    dispSearchResultData: function(apiResponseData) {
      if (apiResponseData == null) {
        return;
      }
      let responseDto = apiResponseData.data;
      let resultDto = responseDto.requestDetailsConfirmResultDto;

      this.dispCustomerId = resultDto.customerId;
      this.dispRequestNo = resultDto.displayRequestNo; 
      this.dispRequestDate = resultDto.displayRequestDate;
      this.dispUserKanaNM = resultDto.nameKana;
      this.dispCompanyKanaNm = resultDto.companyNameKana;
      this.dispUserNM = resultDto.name;
      this.dispCompanyNm = resultDto.companyName;
      this.dispVerifyStatus(resultDto.verifyStatusClass);

      this.dispVerifyResult(resultDto.verifyResult);
      this.verifyDealResultComment = resultDto.verifyResultComment;

      this.detailUpdateDatetime = resultDto.detailUpdateDatetime;
      this.detailUpdateUserId = resultDto.detailUpdateUserId;

      this.managerName = resultDto.managerName;
      this.managerNameKana = resultDto.managerNameKana;
      this.mailAddress = resultDto.mailAddress;
      this.receiptNo = resultDto.receiptNo;
      this.loginUserNo = resultDto.loginUserNo;

      /* -- 申込プラン表示情報 -- */
      this.dispPlanNm = resultDto.displayBasePlanName + "<br/>" + resultDto.displayOptionPlanName;
      // 進捗プルダウン
      this.progress = responseDto.progressList;
      this.selectedProgress = resultDto.latestProgressClass;

      this.unconfirmedInactive = resultDto.unconfirmedInactive;
 
      // ファイル情報パネル高さ調整
      this.modFileViewrHeght();
      this.fileUploadFlg = resultDto.fileUpload;
      /** 役員変更日付 */
      this.getDispChangeOfficerDate(resultDto);
      /* -- 役員情報 -- */
      this.desserts = [];
      if (resultDto.changeOfficerList != null) {
        let changeOfficer;
        for (const value of resultDto.changeOfficerList) {
          changeOfficer = {};
          changeOfficer['changeNo'] = value.changeNo;
          changeOfficer['officialPosition'] = value.officialPosition;
          changeOfficer['name'] = value.name;
          changeOfficer['nameKana'] = value.nameKana;
          changeOfficer['changeOfficerClassName'] = value.changeOfficerClassName;
          changeOfficer['address'] = value.officerAddress;
          // changeOfficer['regmatter'] = Utils.nl2br(value.regmatter);
          this.desserts.push(changeOfficer);
        }
      }
      /* -- 登記変更詳細情報 -- */
      // 改行コード置換, pタグ付加
      // this.dispRegChgInfo = "<p>" + Utils.nl2br(resultDto.regmatterBase) + "</p>";
      // コメント
      this.initCommentInfo = resultDto.comment;
      this.inputCommentInfo = resultDto.comment;

    },
    /*
    * 変更日付
    */
    getDispChangeOfficerDate: function(resultDto) {
      let appointDate = resultDto.appointDate;
      let resignDate = resultDto.resignDate;
      let othersDate = resultDto.othersDate;
      if (appointDate != "" && appointDate != null) {
        this.dispChangeOfficerDate = "株主総会・取締役会の開催日付: " + appointDate;
      }
      if (resignDate != "" && resignDate != null) {
        if (this.dispChangeOfficerDate != "") {
          this.dispChangeOfficerDate = this.dispChangeOfficerDate + "<br/>"
        }
        this.dispChangeOfficerDate = this.dispChangeOfficerDate  + "退任等の日付: " + resignDate;
      }
      if (othersDate != "" && othersDate != null) {
        this.dispChangeOfficerDate = "住所移転日付: " + othersDate;
      }
    },
    /*
    * 本人確認状況表示
    */    
    dispVerifyStatus: function(verifyStatusCd) {
      if (verifyStatusCd == null || verifyStatusCd == "") {
        this.verifyStatus = {name: "未確認", color: "red", icon: "mdi-account-alert-outline"};
        return;
      }
      this.verifyStatusKbnMstList = this.$store.getters["master/getVerifyStatusKbnList"];
      let searchArry = "";
      if (verifyStatusCd != "") {
        searchArry = this.verifyStatusKbnMstList.find((v) => v.value1 === verifyStatusCd);
        this.verifyStatus = {name: searchArry.nameAbbr, color: searchArry.value2, icon:searchArry.value3};
      }
    },

    /*
    * 本人確認処置結果表示
    */    
    dispVerifyResult: function(verifyResult) {
      this.dealResultKbnList = this.$store.getters["master/getDealResultKbnList"];
      let searchArry = "";
      if (verifyResult != "" && verifyResult != null) {
        searchArry = this.dealResultKbnList.find((v) => v.name === verifyResult);
        this.verifyDealResult = {name: searchArry.nameAbbr, color: searchArry.value2, icon:searchArry.value3};
      }
    },

    /*
    * 本人確認処置状況取得後完了メッセージ表示
    */
    showDialogMsgAfterAPICall : function(responseDto) {
      let hasError = false;
      // APIコール異常
      if (responseDto == null) {
        hasError = true;
        this.dlgMsgErr.msg = this.$i18n.t('msg.err.cm110', ['本人確認処置状況の確認']);
        this.dlgMsgErr.isOpen = true;
        return hasError;
      }
      // APIコール正常
      if (responseDto.statusCd != 200) {
        // 処理異常
        hasError = true;
        let errorList = responseDto.errorList;
        if (errorList != null && errorList.length > 0) {
          this.dlgMsgErr.msg = Utils.createMsgViewStringForErrList(errorList);
          this.dlgMsgErr.isOpen = true;
          return hasError;
        }  
      }
      return hasError;
    },

    /*
    * ファイル表示パネル高さ調整
    */
    modFileViewrHeght: function() {
      const iframeFile = document.getElementById("iframeFile");
      // iframeFile.style.height = iframeFile.contentWindow.document.body.scrollHeight + "px";
      iframeFile.style.height = "40vh";
    },
    scrollWindow() {
      const top = 200
      this.scroll = window.scrollY
      if (top <= this.scroll) {
        this.buttonActive = true
      } else {
        this.buttonActive = false
      }
    },
  },
};
</script>

<style scoped>
.panel-title {
  color:#000000;
  background-color: #E0E0E0;
  font-size: 1.2em;
  font-weight: lighter;
}
/* 吹き出し */
.balloon {
  position: relative;
  display: inline-block;
  margin: 1.5em 0 1.5em 15px;
  padding: 7px 10px;
  min-width: 60%;
  max-width: 90%;
  color: #555;
  font-size: 16px;
  background: #ffcd93;
  border-radius: 10px;
}

.balloon:before {
  content: "";
  position: absolute;
  top: 25%;
  left: -15px;
  margin-top: -10px;
  border: 5px solid transparent;
  border-right: 10px solid #ffcd93;
}

@media screen and (max-width: 750px) {

}
</style>
